import { UserGuideImport } from './Imports'
const { RoutesMap, DocumentsList } = UserGuideImport

const UserGuideRoute = () => {
    return [
        {
            path: RoutesMap.DOCUMENTS_LIST.path,
            element: <DocumentsList />
        },
    ]
}

export default UserGuideRoute;
